import React from 'react'
import Link from './Link'
import Image from './Image'

import Placeholder from '../../assets/images/placeholder-logo.svg'
import Headline from './Headline'
import FadeInBottomEffect from '../effect/FadeInBottomEffect'
import Richtext from './Richtext'

const CustomArticleStackedTeaser = ({ item, className }) => {
  return (
    <FadeInBottomEffect
      className={`stacked-teaser-item article-stacked-teaser-item custom-article-stacked-teaser-item ${
        className ? className : ''
      }`}
      tagName="section"
    >
      <article>
        <Link link={item.link} target={item.tab_link ? '_blank' : '_self'}>
          <div
            className={`teaser-item-image${item.image ? '' : '-placeholder'}`}
          >
            <Image
              image={item.image ? item.image : Placeholder}
              alt={item.alt}
              title={item.alt}
            />
          </div>
          <div className="teaser-item-content">
            <div>
              {item.category && (
                <p className="meta-category">{item.category}</p>
              )}
              <Headline
                kicker={item.kicker}
                headline={item.headline}
                subheadline={item.subheadline}
                headline_level="h3"
                tagName="h3"
              />
              {item.text && (
                <Richtext className="teaser-item-text" text={item.text} />
              )}
            </div>
            {item.link_text && (
              <span className="btn btn-primary">{item.link_text}</span>
            )}
          </div>
        </Link>
      </article>
    </FadeInBottomEffect>
  )
}

export default CustomArticleStackedTeaser
